import { siteConfig } from '@/utils/site-config'
import * as R from 'ramda'

import { createDictFromObject } from '@/utils/functions'
import { t } from '@/plugins/i18n'

// 秒
export const SECOND = 1000

// 分
export const MINUTE = 60 * SECOND

export const MAX_CONSTANT = 10e6
// 列表每页默认最少数据
export const PAGE_SIZE = 10

export const createDictFromDictRaw = (dict: DictRaw[]): Dict[] => {
  return dict.map((item) => {
    return {
      value: item.dictValue,
      label: item.dictLabel,
    }
  })
}

export const PayTypeDictMap = (source: Partial<OperationSource>) => {
  const map: any = {
    0: t('payType.hai-bi'),
    1: t('payType.zhang-qi-bao'),
    2: t('payType.vip'),
    4: t('payType.ding-cang'),
  }
  return map[source] as any
}

export const PayTypeDict = createDictFromObject(
  R.invertObj({
    0: t('payType.hai-bi'),
    1: t('payType.zhang-qi-bao'),
    2: t('payType.vip'),
    4: t('payType.ding-cang'),
  }),
)

/**
 * @description 根据字典的值查找值对应的label
 * @param {string|number} value 值
 * @param {Dict[]} dict 查找的字典
 * @return {string} label
 */
export const getDictLabel = (value: string | number, dict?: Dict[]): string =>
  R.pipe(
    R.defaultTo([]) as (arr?: Dict[]) => Dict[],
    R.find(R.propEq(value?.toString(), 'value')) as (
      arr: Dict[],
    ) => Dict | undefined,
    R.propOr('', 'label') as (dict?: Dict) => string,
  )(dict)

/**
 * @description 根据字典的值查找值对应的label
 * @param {string|number} label 值
 * @param {Dict[]} dict 查找的字典
 * @return {string} value
 */
export const getDictValue = (label: string | number, dict?: Dict[]): string =>
  R.pipe(
    R.defaultTo([]) as (arr?: Dict[]) => Dict[],
    R.find(R.propEq(label, 'label')) as (arr: Dict[]) => Dict | undefined,
    R.propOr('', 'value') as (dict?: Dict) => string,
  )(dict)

export enum AckStatus {
  /** 已提交 */
  SUBMITTED = 'SUBMITTED',
  /** 接受成功 */
  SEND_SUCCESS = 'SEND_SUCCESS',
  /** 接受失败 */
  SEND_FAILURE = 'SEND_FAILURE',
  /** 修改成功 */
  AMEND_SUCCESS = 'AMEND_SUCCESS',
  /** 修改失败 */
  AMEND_FAILURE = 'AMEND_FAILURE',
  /** 删单成功 */
  DELETE_SUCCESS = 'DELETE_SUCCESS',
  /** 删单失败 */
  DELETE_FAILURE = 'DELETE_FAILURE',
}

export const getAckStatusMap = (status: Partial<AckStatus>) => {
  const map = {
    SUBMITTED: t('ackStatus.SUBMITTED'),
    SEND_SUCCESS: t('ackStatus.SEND_SUCCESS'),
    SEND_FAILURE: t('ackStatus.SEND_FAILURE'),
    AMEND_SUCCESS: t('ackStatus.AMEND_SUCCESS'),
    AMEND_FAILURE: t('ackStatus.AMEND_FAILURE'),
    DELETE_SUCCESS: t('ackStatus.DELETE_SUCCESS'),
    DELETE_FAILURE: t('ackStatus.DELETE_FAILURE'),
  }
  return map[status]
}

// 申报状态
export const AckStatusMap = () => {
  return {
    SUBMITTED: t('ackStatus.SUBMITTED'),
    SEND_SUCCESS: t('ackStatus.SEND_SUCCESS'),
    SEND_FAILURE: t('ackStatus.SEND_FAILURE'),
    AMEND_SUCCESS: t('ackStatus.AMEND_SUCCESS'),
    AMEND_FAILURE: t('ackStatus.AMEND_FAILURE'),
    DELETE_SUCCESS: t('ackStatus.DELETE_SUCCESS'),
    DELETE_FAILURE: t('ackStatus.DELETE_FAILURE'),
  }
}

export const AckStatusColorMap: Record<string, string> = {
  SUBMITTED: '#006AFF',
  SEND_SUCCESS: '#30BF78',
  SEND_FAILURE: '#F46144',
  AMEND_SUCCESS: '#30BF78',
  AMEND_FAILURE: '#F46144',
  DELETE_SUCCESS: '#30BF78',
  DELETE_FAILURE: '#F46144',
}

export const AckStateDict = () => {
  return createDictFromObject(R.invertObj(AckStatusMap()))
}

export enum RiskStatus {
  /** 通过 */
  PASSED = 'PASSED',
  /** 拒绝 */
  FAILED = 'FAILED',
}

export const RiskStatusColorMap: Record<string, string> = {
  PASSED: '#30BF78',
  FAILED: '#F46144',
}

export const enum OperationSource {
  WEB = 'WEB',
  PIPELINE = 'PIPELINE',
  HGJ = 'HGJ',
}

export const getOperationSourceMap = (source: Partial<OperationSource>) => {
  const map = {
    WEB: t('operationSource.WEB'),
    PIPELINE: t('operationSource.PIPELINE'),
    HGJ: t('operationSource.HGJ'),
  }
  return map[source] as any
}

// 操作来源
export const OperationSourceMap = () => {
  const map = {
    WEB: t('operationSource.WEB'),
    PIPELINE: t('operationSource.PIPELINE'),
    HGJ: t('operationSource.HGJ'),
  }
  return map as any
}

export const OperationSourceDict = () =>
  createDictFromObject(R.invertObj(OperationSourceMap()))

// 操作类型
export const OperationTypeMap = () => {
  const map = {
    SEND: t('operationType.SEND'),
    AMEND: t('operationType.AMEND'),
    DELETE: t('operationType.DELETE'),
  }
  return map as any
}

export const OperationTypeDict = () =>
  createDictFromObject(R.invertObj(OperationTypeMap()))

// 操作类型
export const getOperationTypeMap = (type: string) => {
  const map: any = {
    SEND: t('operationType.SEND'),
    AMEND: t('operationType.AMEND'),
    DELETE: t('operationType.DELETE'),
  }
  return map[type] as any
}

/**
 * 公共中台优惠券地址
 * 可配置 tabName=experience
 */
export const CONST_USER_COUPON_PATH = 'i.hgj.com/main/coupon/ent'

/**
 * 公共中台充值记录地址
 * 可配置 merchandiseType=1
 */
export const CONST_USER_RECHARGE_PATH = 'i.hgj.com/main/bill/ent/ent-pay'

/**
 * 公共中台开票记录地址
 * 可配置 productGroupCode=product_group_sea tabName=sea
 */
export const CONST_USER_INVOICING_PATH = 'i.hgj.com/main/bill/ent/entInvoice'

// 公共中台海币充值地址
export const CONST_USER_PAY_PATH = 'mall.hgj.com/sea/pay'

/** 联系客服地址 */
export const CONST_CUSTOMER_SERVICE_URL =
  'https://shouqian.soboten.com/chat/pc/v2/index.html?sysnum=a0615bcb74d9419299a9b5bea64efee0&channelid=11'

// 用户登录中心
export const CONST_USER_LOGIN = siteConfig.loginUrl

// 用户企业认证
export const CONST_USER_ENTERPRISE_CERTIFICATION = 'i.hgj.com/auth-process'

/**
 * 站点地址
 */
export const SiteMap = {
  // 个人中心-优惠券
  coupon: CONST_USER_COUPON_PATH,
  // 个人中心-充值记录
  recharge: CONST_USER_RECHARGE_PATH,
  // 个人中心-开票记录
  invoicing: CONST_USER_INVOICING_PATH,
  // 商城-海币充值
  pay: CONST_USER_PAY_PATH,
  // 登录
  login: CONST_USER_LOGIN,
  // 个人中心-企业认证
  enterprise: CONST_USER_ENTERPRISE_CERTIFICATION,
}

/** 登录用户产品审核状态 */
export enum USER_AUDIT_STATUS {
  /** 开通 */
  ACCEPTED = 'ACCEPTED',
  /** 驳回 */
  REJECTED = 'REJECTED',
  /** 提交 */
  SUBMITTED = 'SUBMITTED',
}

export enum AdditionalInfoStatus {
  /** 待补充 */
  WAITING = 'WAITING',
  /** 已提交 */
  SUBMITTED = 'SUBMITTED',
  /** 已补充 */
  ACCEPTED = 'ACCEPTED',
  /** 补充失败 */
  REJECTED = 'REJECTED',
}
export const getAdditionalInfoStatusMap = (status: AdditionalInfoStatus) => {
  const map = {
    WAITING: t('additionalInfoStatus.WAITING'),
    SUBMITTED: t('additionalInfoStatus.SUBMITTED'),
    ACCEPTED: t('additionalInfoStatus.ACCEPTED'),
    REJECTED: t('additionalInfoStatus.REJECTED'),
  }
  return map[status]
}
// 补充信息状态 WAITING:待补充SUBMITTED:已提交,ACCEPTED:已补充,REJECTED:补充失败
export const AdditionalInfoStatusMap: Record<string, string> = {
  WAITING: '待补充',
  SUBMITTED: '已提交',
  ACCEPTED: '已补充',
  REJECTED: '补充失败',
}

export const AdditionalInfoStatusColorMap: Record<string, string> = {
  WAITING: '#FFAA00',
  SUBMITTED: '#006AFF',
  ACCEPTED: '#30BF78',
  REJECTED: '#F46144',
}
export const AdditionalInfoStatusDict = createDictFromObject(
  R.invertObj(AdditionalInfoStatusMap),
)

export const EoriNoStatusColorMap: Record<string, string> = {
  PENDING: '#006AFF',
  REJECTED: '#F46144',
  ENABLED: '#30BF78',
  DISABLED: '#F46144',
}

// PENDING:审核中,REJECTED:驳回,ENABLED:启用,DISABLED:禁用
export enum EoriNoStatus {
  /** 审核中 */
  PENDING = 'PENDING',
  /** 驳回 */
  REJECTED = 'REJECTED',
  /** 启用 */
  ENABLED = 'ENABLED',
  /** 禁用 */
  DISABLED = 'DISABLED',
}

// PENDING:审核中,REJECTED:驳回,ENABLED:启用,DISABLED:禁用
export const getEoriNoStatusStatusMap = (status: EoriNoStatus) => {
  const map = {
    PENDING: t('eoriNoStatus.PENDING'),
    REJECTED: t('eoriNoStatus.REJECTED'),
    ENABLED: t('eoriNoStatus.ENABLED'),
    DISABLED: t('eoriNoStatus.DISABLED'),
  }
  return map[status]
}

// 查询状态
export enum QueryStatus {
  /** 查询中 */
  SUBMITTED = 'SUBMITTED',
  /** 查询成功 */
  QUERY_SUCCESS = 'QUERY_SUCCESS',
  /** 查询失败 */
  QUERY_FAILURE = 'QUERY_FAILURE',
}

export const getQueryStatusMap = (status: Partial<QueryStatus>) => {
  const map = {
    SUBMITTED: t('queryStatus.SUBMITTED'),
    QUERY_SUCCESS: t('queryStatus.QUERY_SUCCESS'),
    QUERY_FAILURE: t('queryStatus.QUERY_FAILURE'),
  }
  return map[status]
}
export const QueryStatusMap = () => {
  const map = {
    SUBMITTED: t('queryStatus.SUBMITTED'),
    QUERY_SUCCESS: t('queryStatus.QUERY_SUCCESS'),
    QUERY_FAILURE: t('queryStatus.QUERY_FAILURE'),
  }
  return map
}

export const QueryStatusColorMap: Record<string, string> = {
  SUBMITTED: '#006AFF',
  QUERY_SUCCESS: '#30BF78',
  QUERY_FAILURE: '#F46144',
}

export const QueryStatusDict = () =>
  createDictFromObject(R.invertObj(QueryStatusMap()))
